import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueFriendlyIframe from 'vue-friendly-iframe'
Vue.use(VueFriendlyIframe)

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)


/* https://www.npmjs.com/package/@fortawesome/vue-fontawesome */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faHome, faInstagram)


Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
